const OutlierDetectorType = {
	AutoEncoder: 'AutoEncoder',
	OneClassSvm: 'OneClassSvm',
	IsolationForest: 'IsolationForest',
	LocalOutlierFactor: 'LocalOutlierFactor',
	RuleBased: 'RuleBased'
};

export default OutlierDetectorType;